module.exports = __webpack_public_path__ + "static/6-e3bbab8d37ba508809f78c4baf02ebdb.woff";